import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'
import { DeviceNameConflictError, DeviceStateConflictError, isNameConflict, isDeviceStateConflict } from '../deviceErrors'

interface ReactivateDeviceResult {
  pairingCode: string
  expiresAt: Date
}

async function reactivateDevice(deviceId: string): Promise<ReactivateDeviceResult> {
  const { data, error } = await supabase
    .rpc('reactivate_device', { p_device_id: deviceId })
  if (error) {
    if (isNameConflict(error)) throw new DeviceNameConflictError()
    if (isDeviceStateConflict(error)) throw new DeviceStateConflictError()
    reportUnexpectedError(error)
    throw error
  }
  return {
    pairingCode: data.pairing_code as string,
    expiresAt: new Date(data.expires_at as string),
  }
}

export function useReactivateDevice() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: reactivateDevice,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['devices'] }),
  })
}
